import { createContext, useContext, useEffect, useState, type ReactNode } from 'react'

type PageHeaderValue = {
  eyebrow: string
  title: string
}

type PageHeaderContextValue = {
  header: PageHeaderValue
  setHeader: (value: PageHeaderValue) => void
}

const EMPTY_HEADER: PageHeaderValue = { eyebrow: '', title: '' }

const PageHeaderContext = createContext<PageHeaderContextValue | null>(null)

export function PageHeaderProvider({ children }: { children: ReactNode }) {
  const [header, setHeader] = useState<PageHeaderValue>(EMPTY_HEADER)
  return (
    <PageHeaderContext.Provider value={{ header, setHeader }}>
      {children}
    </PageHeaderContext.Provider>
  )
}

function usePageHeaderContext(): PageHeaderContextValue {
  const context = useContext(PageHeaderContext)
  if (!context) {
    throw new Error('usePageHeader must be used within PageHeaderProvider')
  }
  return context
}

export function usePageHeader(eyebrow: string, title: string) {
  const { setHeader } = usePageHeaderContext()
  useEffect(() => {
    setHeader({ eyebrow, title })
  }, [eyebrow, title, setHeader])
}

export function useCurrentPageHeader(): PageHeaderValue {
  return usePageHeaderContext().header
}
